<template>
  <div>
    <slot name="list" v-if="listed">
      <media-list ref="media-list" :show-delete="!displayOnly" @delete-media="removeAttachment" :medias="existingAttachments"/>
    </slot>
    <vue-dropzone
      v-permission="'schedule_events.attachment.put'"
      v-if="!displayOnly"
      id="upload"
      ref="dropzone"
      @vdropzone-success="successSendFormWithFile"
      @vdropzone-sending="sendFormWithFile"
      @vdropzone-error="dropzoneErrorHandler"
      @vdropzone-file-added="fileAdded"
      @vdropzone-queue-complete="complete"
      :use-font-awesome="true"
      :options="dropzoneOptions"
      :use-custom-dropzone-options="true"
      :validation-allowed-extensions="['.pdf', '.docx', '.doc', '.xls', '.xlsx', '.ppt', '.pptx', '.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tiff']"
      :maxNumberOfFiles="1"
      :useCustomSlot="true"
    >
      <div class="dropzone-custom-content">
        Arraste e solte para enviar um arquivo
        <p class="separator">
          <span class="separator-span"> ou </span>
        </p>
        <b-button
          type="button"
          class="btn waves-effect outline-primary"
          variant="outline-secondary"
          >Selecionar</b-button
        >
      </div>
      <slot
        v-if="$refs.dropzone"
        name="meta"
        :dropzone="$refs.dropzone"
        :processQueue="$refs.dropzone.processQueue"
        :fileCount="$refs.dropzone.getQueuedFiles().length"
      />
    </vue-dropzone>
  </div>
</template>

<script>
import MediaList from '@/components/media/MediaList.vue'
import ScheduleEventService from '@/services/api/ScheduleEventService'
import Vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  model: {
    prop: 'files',
    event: 'update:files'
  },
  props: {
    files: {
      type: Array,
      default: () => []
    },
    listed: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: null
    },
    displayOnly: {
      type: Boolean,
      default: false
    },
    dontAutoFetch: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dropzoneOptions: {},
    filesAdded: [],
    existingAttachments: [],
    listRender: 0,
  }),
  components: {
    VueDropzone: Vue2Dropzone,
    MediaList,
  },
  watch: {
    files(val) {
      this.updateFilesAdded(val)
    }
  },
  beforeMount() {
    this.dropzoneOptions = {
      url: `${process.env.VUE_APP_API_BASE_URL}/api/v1/schedule_events/${this.id}/attachment`,
      addRemoveLinks: true,
      autoProcessQueue: false,
      thumbnailWidth: 200,
      createImageThumbnails: true,
      acceptedFiles: 'application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.presentation, image/jpeg, image/png, image/gif, image/bmp, image/tiff',
      dictInvalidFileType: 'Arquivos somente no(s) formato(s) permitido(s): .pdf, .docx, .doc, .xls, .xlsx, .ppt, .pptx, .jpg, .jpeg, .png, .gif, .bmp, .tiff',
      dictRemoveFile: 'Remover arquivo',
    }
  },
  mounted() {
    this.updateFilesAdded(this.files)
  },
  created() {
    this.service = ScheduleEventService.build(this.$vs)
    this.getFileAttachments().then(
      () => {
        this.$vs.loading.close()
      }
    )
  },
  methods: {
    getFileAttachments() {
      const id = this.id
      if (id && !this.dontAutoFetch) {
        return this.service.getAttachments(id).then(
          (response) => {
            if (this._.isArray(response)) {
              this.existingAttachments = response
            } else {
              console.info("Strange, the attachments response should've been an array, but instead is:", response)
            }
          },
          (error) => {
            this.notifyError(this.$vs, 'Erro ao buscar anexos do agendamento.')
          }
        )
      } else {
        console.info("Wont be fetching attachments yet...")
        return new Promise((res, rej) => {
          res()
        })
      }
    },
    updateFilesAdded(val) {
      if (this._.isArray(val)) {
        this.filesAdded = val
      }
    },
    successSendFormWithFile(file, data) {
      // this.successSend(data)
      this.getFileAttachments()
      this.$refs.dropzone.removeAllFiles()
    },
    sendFormWithFile(file, xhr, formData) {
      // let data = _.transform(
      //   this.getDataFields(),
      //   (form, value, field) => {
      //     if (!this._.isEmpty(value) || this._.isNumber(value)) {
      //       formData.append(field, value)
      //     }
      //   },
      //   new FormData()
      // )
    },
    dropzoneErrorHandler(event) {
      console.error('The file dropzone suffered an error', event)
    },
    fileAdded(file) {
      this.filesAdded.push(file)
      this.$emit('update:files', this.filesAdded)
    },
    removeAttachment(item) {
      this.$vs.loading()

      this.service.deleteAttachment(this.id, item.id).then(
        response => {
          this.notifySuccess(this.$vs, "Anexo removido!")
          this.getFileAttachments()
        },
        error => {
          this.notifyError(this.$vs, "Não foi possível remover o anexo.")
        }
      ).finally(
        () => {
          this.$vs.loading.close()
          this.attachmentRenderKey++
        }
      )
    },
  },
}
</script>

<style>

</style>